<template>
  <div
    class="focus-within:border-bdr-active group flex cursor-pointer items-center gap-3 rounded-xl border p-2 pr-3 transition duration-300"
    :class="[
      inputValue === value
        ? 'border-bdr-active shadow-focus bg-bgr-active'
        : 'border-bdr-default hover:border-bdr-hover bg-bgr-default',
    ]"
    @click="inputValue = value"
  >
    <IconColored v-if="iconSrc" :src="iconSrc" :size="iconSize" :color="iconColor" />
    <div>
      <p class="text-cta-default text-fgr-primary no-underline">{{ title }}</p>
      <p class="text-body-small text-fgr-secondary">{{ subtitle }}</p>
    </div>
    <InputRadio v-model="inputValue" class="ml-auto" :value="value" />
  </div>
</template>

<script setup lang="ts">
  const {
    name = "",
    disabled = false,
    iconColor = ComponentColor.Teal,
  } = defineProps<{
    name?: string;
    disabled?: boolean;
    iconSize?: string;
    iconColor?: ComponentColor;
    iconSrc?: string;
    title?: string;
    subtitle?: string;
    value?: string | number | boolean;
  }>();

  const inputValue = defineModel<string | number | boolean>({
    required: true,
  });
</script>
